import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  detailsButton: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  detailsButtonIcon: {
    fontSize: theme.spacing(2.25)
  }
}));

const DetailsButton = memo(({ className }) => {
  const classes = useStyles();

  return (
    <Box
      className={classNames(classes.detailsButton, className)}
      tabIndex={-1}
      aria-hidden="true"
      data-qe-id="periodBlockButton"
    >
      <ExpandMoreIcon className={classes.detailsButtonIcon} />
    </Box>
  );
});

DetailsButton.propTypes = {
  className: PropTypes.string
};

export default DetailsButton;
